import { AxiosResponse } from 'axios';
import userClient from 'src/api/userClient';
import { UserInspectorResource } from 'types/userAccount';

export const createUpdateInspectorAccount = (
  inspectorEmail: string,
  forceNewPassword: boolean
): Promise<AxiosResponse<UserInspectorResource>> => {
  return userClient.post<UserInspectorResource>(
    '/api/Inspector/CreateOrActivedInspectorDTAccount',
    null,
    {
      params: {
        email: inspectorEmail,
        forceNewPassword: forceNewPassword,
      },
    }
  );
};

export default createUpdateInspectorAccount;
